import { UPDATE_WINDOW_SIZE, WindowSizeActionTypes, WindowSizeDataState } from "../types/windowsize.type";

interface WindowSizeState {
    dataSize: WindowSizeDataState
}
const initialState: WindowSizeState = {
    dataSize: {
        width: 0,
        height: 0,
        isMobile: false,
    }
};

export function windowSizeReducer(state: WindowSizeState = initialState, action: WindowSizeActionTypes): WindowSizeState {
  switch (action.type) {
    case UPDATE_WINDOW_SIZE: {
      return {
        ...state,
        dataSize: action.payload,
      };
    }
    default:
      return state
  }
};